import React, { FC, useCallback, useState } from 'react';
import './checkbox.scss';

interface Props {
  label?: string;
  value?: boolean;
  handleChange?: (e: boolean) => void;
}

const Checkbox: FC<Props> = ({label, value, handleChange}) => {
  const checkboxId = Math.floor(Math.random() * 1000000).toString();

  const [isChecked, setIsChecked] = useState(value ?? true);


  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(e.target.checked);
      if (handleChange) {
        handleChange(e.target.checked);
      }
    },
    [handleChange]
  );

  return (
    <div className="custom-checkbox__container">
      <input id={checkboxId} className="custom-checkbox" type="checkbox" checked={isChecked} onChange={(e) => onInputChange(e)} />
      <label className="setting-label" htmlFor={checkboxId}>{label}</label>
    </div>
  )
};

export default Checkbox;
